import { useQueryClient } from "@tanstack/react-query";

import { ASSIGN_MATERIALS_KEYS } from "../services/queryKeys";

export const useRefetchAssignMaterialsList = () => {
  const queryClient = useQueryClient();

  return {
    refetchList: () => {
      queryClient.invalidateQueries({ queryKey: [ASSIGN_MATERIALS_KEYS.RECORDS] });
    },
  };
};
